import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.99 14.01V22H13.97V15.01C13.97 14.46 13.52 14.01 12.96 14.01H5.03C4.47 14.01 4.02 14.46 4.02 15.01V22H2V14.01C2 12.9 2.9 12.01 4.02 12.01H13.97C15.08 12.01 15.99 12.91 15.99 14.01ZM17 8.9V10.9H22V8.9H17ZM4.49 6.47C4.49 4.01 6.51 2 8.99 2C11.47 2 13.5 4.01 13.5 6.47C13.5 8.93 11.48 10.94 8.99 10.94C6.5 10.94 4.49 8.94 4.49 6.47ZM6.51 6.47C6.51 7.83 7.63 8.94 9 8.94C10.37 8.94 11.49 7.83 11.49 6.47C11.49 5.11 10.37 4 9 4C7.63 4 6.51 5.11 6.51 6.47Z" fill={ fill || 'currentColor' } />
        <path d="M22 4.9H16V6.9H22V4.9Z" fill={ fill || 'currentColor' } />
        <path d="M22 12.9H18V14.9H22V12.9Z" fill={ fill || 'currentColor' } />
    </svg>

);
